import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
export class UtilService{
    groupByRoleName(roles, getRoleName) {
        const map = new Map();
        roles.forEach((role) => {
          const key = getRoleName(role);
          const collection = map.get(key);
          if (!collection) {
            map.set(key, [role]);
          } else {
            collection.push(role);
          }
        });
        return map; 
      }

      declarePlural(originalObject : any[] , singular : string , plural : string ) : string{
        return originalObject.length == 1 ? singular :plural;
     }
}